export const OPEN_TRIAL_EXCEEDED_MODAL = "OPEN_TRIAL_EXCEEDED_MODAL";
export const CLOSE_TRIAL_EXCEEDED_MODAL = "CLOSE_TRIAL_EXCEEDED_MODAL";
export const OPEN_TRIAL_LIMITATIONS_MODAL = "OPEN_TRIAL_LIMITATIONS_MODAL";
export const CLOSE_TRIAL_LIMITATIONS_MODAL = "CLOSE_TRIAL_LIMITATIONS_MODAL";
export const OPEN_SUBSCRIPTION_UPGRADE_NEEDED =
  "OPEN_SUBSCRIPTION_UPGRADE_NEEDED";
export const CLOSE_SUBSCRIPTION_UPGRADE_NEEDED =
  "CLOSE_SUBSCRIPTION_UPGRADE_NEEDED";
export const SET_STORE_CONFIGURATION_MODAL_VISIBILITY =
  "SET_STORE_CONFIGURATION_MODAL_VISIBILITY";
export const SET_CREATOR_SEARCH_LOCKED_MODAL_VISIBILITY =
  "SET_CREATOR_SEARCH_LOCKED_MODAL_VISIBILITY";
export const SET_OUTSIDE_CLICK_WARNING_MODAL_VISIBILITY =
  "SET_OUTSIDE_CLICK_WARNING_MODAL_VISIBILITY";
